import CheckIcon from '@material-ui/icons/Check';
import classnames from 'classnames';
import { bool, string } from 'prop-types';

import Image from '~/components/Image';

import style from './DailyRewardImage.module.scss';

export default function DailyRewardImage({
  path,
  src,
  alt,
  collected,
  className,
  classNameCheck,
}) {
  return (
    <div className={classnames(style.imageWrapper, className)}>
      <Image
        className={classnames(collected && style.rewardImageCollected)}
        path={path}
        src={src}
        alt={alt}
      />
      <CheckIcon
        className={classnames(
          style.check,
          { [style.collected]: collected },
          classNameCheck,
        )}
      />
    </div>
  );
}

DailyRewardImage.propTypes = {
  path: string,
  src: string,
  alt: string.isRequired,
  className: string,
  classNameCheck: string,
  collected: bool,
};
